import { render } from "./TicketsList.vue?vue&type=template&id=51c5592a"
import script from "./TicketsList.vue?vue&type=script&lang=js"
export * from "./TicketsList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__